/**
 * zod, in jitless mode. The build routes every import of `zod` and `zod/v4` here (see the
 * `zodJitless` plugin in `vite.config.ts`); this module's own import of `zod` is the one that
 * reaches the package. Both entries export the same API, so one wrapper serves both.
 */
import { z } from 'zod';

z.config({ jitless: true });

export * from 'zod';
export { z, z as default };
